import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { Button, Grid, MenuItem, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { isNotEmpty } from '../../utils/helpers'
import OfoqThemeBtn from '../Buttons/OfoqThemeBtn.jsx'
import OfoqTextField from '../Forms/OfoqTextField.jsx'
import FormModalContainer from './FormModalContainer.jsx'
import FinishModal from './FinishModalContainer.jsx'
import OfoqDropdown from '../Forms/OfoqDropdown.jsx'
import { lastTenant, retrieveCompanies, retrieveCompaniesModules, retrieveCompaniesFabsTenants } from '../../redux/features/companies/companiesThunk'
import OfoqAutoComplete from '../Forms/OfoqAutoComplete'
import { selectCompanies } from '../../redux/features/companies/companiesSlice'
import ConfirmationModalContainer from './ConfirmationModalContainer.jsx'

const CompanyModal = ({
  actionToDispatch,
  modalTitle,
  modalMessage,
  data,
  formState,
  setFormState,
  disableButton,
  disableIntegrationType,
}) => {
  const dispatch = useDispatch()
  const companiesStore = useSelector(selectCompanies)

  const [formModalState, setFormModalState] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)
  const [companyName, setCompanyName] = useState(data?.company?.name)
  const [applicantUrl, setApplicantUrl] = useState(data?.company?.domain)
  const [integrationType, setIntegrationType] = useState(data?.integration?.type)
  const [url, setUrl] = useState(data?.integration?.url)
  const [username, setUsername] = useState(data?.integration?.username)
  const [companyModules, setCompanyModules] = useState(data?.company?.modules)
  const [password, setPassword] = useState(null)
  const [dimmed, setDimmed] = useState(false)
  const [coreTenant, setCoreTenants] = useState(data?.company?.tenant_list?.[0].fabs_tenant)
  const [confirmation1ModalState, setConfirmation1ModalState] = useState(false)
  const [confirmation2ModalState, setConfirmation2ModalState] = useState(false)

  const showApplicantPortalURL = companyModules?.find((item) => item?.code === 'recruitment')
  const tenant = data?.tenant
  const { enqueueSnackbar } = useSnackbar()

  const integrationTypeList = ['STANDALONE', 'OTMS', 'OTMS_V2']

  useEffect(() => {
    if (integrationType === 'OTMS_V2') {
      dispatch(retrieveCompaniesFabsTenants())
    }
  }, [integrationType])

  useEffect(() => {
    if (formState) handleOpen()
  }, [formState])

  const passwordEmptyHandler = () => {
    if (password === '      ') {
      setPassword('')
    }
  }

  const resetModalFields = () => {
    setCompanyName(data?.company?.name)
    setApplicantUrl(data?.company?.domain)
    setIntegrationType(data?.integration?.type)
    setUrl(data?.integration?.url)
    setUsername(data?.integration?.username)
    setCompanyModules(data?.company?.modules)
    setPassword('      ')
    setCoreTenants(data?.company?.tenant_list?.[0].fabs_tenant || null)
  }

  const handleOpen = () => {
    if (!disableIntegrationType) {
      dispatch(lastTenant()).then((response) => {
        if (!isNotEmpty(response.payload) && response.meta.requestStatus === 'fulfilled') {
          setDimmed(true)
          enqueueSnackbar('No more tenants available', { variant: 'error' })
        }
      })
      dispatch(retrieveCompaniesModules())
    }
    resetModalFields()
    setFormModalState(true)
  }

  function handleClose() {
    resetModalFields()
    setFormModalState(false)
    if (formState) setFormState(false)
  }

  function confirmHandler() {
    if (
      integrationType === 'OTMS' &&
      isNotEmpty(companyName) &&
      isNotEmpty(applicantUrl) &&
      isNotEmpty(integrationType) &&
      isNotEmpty(url) &&
      isNotEmpty(companyModules) &&
      isNotEmpty(username) &&
      (isNotEmpty(password) || disableIntegrationType) &&
      isNotEmpty(tenant)
    ) {
      const module_ids = []
      companyModules.forEach((singleModule) => {
        module_ids.push(singleModule.id)
      })

      const requestObj = {
        name: companyName,
        domain: applicantUrl,
        integration_type: integrationType,
        module_ids,
        otms_integration: {
          url,
          username,
          password: isNotEmpty(password) && password !== '      ' ? password : null,
        },
        tenant_id: tenant.id,
      }
      handleDispatch(requestObj)
    } else if (integrationType === 'OTMS_V2') {
      if (isNotEmpty(companyName) &&
        isNotEmpty(integrationType) &&
        (!showApplicantPortalURL || isNotEmpty(applicantUrl)) &&
        isNotEmpty(companyModules) &&
        isNotEmpty(tenant) &&
        isNotEmpty(coreTenant)) {
        const module_ids = []
        companyModules.forEach((singleModule) => {
          module_ids.push(singleModule.id)
        })

        const requestObj = {
          name: companyName,
          domain: applicantUrl,
          integration_type: integrationType,
          module_ids,
          tenant_id: tenant.id,
          fabs_tenant_id: coreTenant?.id,
        }
        handleDispatch(requestObj)
      } else {
        enqueueSnackbar('Please fill in the required fields', { variant: 'error' })
      }
    } else if (integrationType === 'STANDALONE') {
      if (isNotEmpty(companyName) &&
        isNotEmpty(integrationType) &&
        isNotEmpty(applicantUrl) &&
        isNotEmpty(tenant)) {
        const requestObj = {
          name: companyName,
          domain: applicantUrl,
          integration_type: integrationType,
          tenant_id: tenant.id,
        }
        handleDispatch(requestObj)
      } else {
        enqueueSnackbar('Please fill in the required fields', {
          variant: 'error',
        })
      }
    } else if (!isNotEmpty(tenant)) {
      enqueueSnackbar('There are no available tenants. Please contact your system administrator', {
        variant: 'error',
      })
    } else {
      enqueueSnackbar('Please fill in the required fields', { variant: 'error' })
    }
  }

  const handleDispatch = (requestObj) => {
    dispatch(
      actionToDispatch({
        body: requestObj,
        id: data?.company?.id,
      }),
    ).then((response) => {
      if (response.payload.message || response.payload.debugMessage) {
        enqueueSnackbar(response.payload.message || response.payload.debugMessage, { variant: 'error' })
      } else {
        handleClose()
        setFinishModalState(true)
      }
    })
  }

  const FinishHandler = () => {
    dispatch(retrieveCompanies())
    setFinishModalState(false)
  }

  const confirmation2ModalData = {
    header: modalTitle || '',
    body: `Please make sure that the core tenant "${coreTenant?.name}" is correct , once this company is created, you can't change its core tenant anymore.`,
    error: '',
    cancelText: 'Cancel',
    confirmText: 'Yes, continue',
    subBody: 'Are you sure you want to continue?',
  }

  const handelSave = () => {
    if (modalTitle === 'Add New Company' && integrationType === 'OTMS_V2') {
      if (isNotEmpty(companyName) &&
        isNotEmpty(integrationType) &&
        (!showApplicantPortalURL || isNotEmpty(applicantUrl)) &&
        isNotEmpty(companyModules) &&
        isNotEmpty(tenant) &&
        isNotEmpty(coreTenant)) {
        setConfirmation1ModalState(true)
      } else {
        enqueueSnackbar('Please fill in the required fields', { variant: 'error' })
      }
    } else {
      confirmHandler()
    }
  }

  return (
    <>
      {!disableButton && (
        <Button onClick={handleOpen} sx={styles.modalBtn}>
          Add Company
        </Button>
      )}

      <FormModalContainer
        modalState={formModalState}
        handleClose={handleClose}
        modalTitle={modalTitle}>
        <Grid container xs={12} justifyContent='space-between' sx={styles.companyInputContainer}>
          <Grid item xs={5.8}>
            <OfoqTextField
              name='Company Name'
              defaultValue={companyName}
              refState={setCompanyName}
              type='text'
              required
              customStyle={styles.companyInput}
            />
          </Grid>
          <Grid item xs={5.8}>
            <OfoqTextField placeholder={tenant?.name} name='tenant' disabled type='text' customStyle={styles.companyInput} />
          </Grid>
        </Grid>

        <OfoqDropdown
          name='integration'
          state={isNotEmpty(integrationType) ? integrationType : ''}
          disabled={disableIntegrationType}
          refState={setIntegrationType}
          customStyle={styles.DropdownInput}
          required={modalTitle === 'Add New Company'}
        >
          {
            <MenuItem disabled key='0' value=''>
              Select Integration
            </MenuItem>
          }
          {integrationTypeList.map((option, index) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
        </OfoqDropdown>

        {integrationType === 'OTMS_V2' && (
          <OfoqAutoComplete
            name='core tenant'
            defaultOption={coreTenant}
            refState={setCoreTenants}
            optionsConfig={companiesStore.fabsTenants}
            customStyle={styles.autoCompleteInput}
            required={modalTitle === 'Add New Company'}
            disabled={disableIntegrationType}
          />
        )}

        {(integrationType === 'OTMS' || integrationType === 'OTMS_V2') &&
          <OfoqAutoComplete
            name='modules'
            defaultOption={companyModules}
            refState={setCompanyModules}
            optionsConfig={companiesStore.companyModules}
            customStyle={styles.autoCompleteInput}
            required
            multiple />
        }

        {(showApplicantPortalURL || integrationType === 'STANDALONE') &&
          <OfoqTextField
            name='applicant_portal_URL'
            defaultValue={applicantUrl}
            refState={setApplicantUrl}
            type='url'
            customPlaceHolder={'Type the Applicant Portal URL'}
            required
            customStyle={styles.companyInput}
          />
        }

        {integrationType === 'OTMS' && isNotEmpty(integrationType) && (
          <>

            <OfoqTextField
              name='integration_URL'
              defaultValue={url}
              refState={setUrl}
              type='url'
              required
              customStyle={styles.companyInput}
            />
            <Grid container xs={12} justifyContent='space-between'>
              <Grid item xs={5.8}>
                <OfoqTextField
                  name='User Name'
                  defaultValue={username}
                  refState={setUsername}
                  type='text'
                  required
                  customStyle={styles.companyInput}
                />
              </Grid>
              <Grid item xs={5.8}>
                <OfoqTextField
                  name='password'
                  placeholder='Enter Password'
                  defaultValue={password}
                  refState={setPassword}
                  type='password'
                  required
                  onClick={passwordEmptyHandler}
                  customStyle={styles.companyInput}
                />
              </Grid>
            </Grid>
          </>
        )}

        <Box sx={styles.formModalBtnsContainer}>
          <OfoqThemeBtn cancelStyle onClick={handleClose} name='cancel' customStyle={styles.actionBtn} />
          <OfoqThemeBtn dimmed={dimmed} disabled={dimmed} onClick={handelSave} name='save' customStyle={styles.actionBtn} />
        </Box>
      </FormModalContainer>

      <FormModalContainer
        modalState={confirmation1ModalState}
        handleClose={() => setConfirmation1ModalState(false)}
        modalTitle={modalTitle}
        mediumSize
        customStyle={{ p: '20px' }}
      >

        <Typography sx={styles.span}>
          Do you want to create new company with name  <span >{companyName}</span>,
          for core tenant <span>{coreTenant?.name}</span> ?
        </Typography>

        <Typography sx={[styles.span, styles.span2]}>
        Please confirm
        </Typography>

        <Box sx={styles.buttonsContainer}>
          <OfoqThemeBtn name={'Cancel'} cancelStyle onClick={() => setConfirmation1ModalState(false)}
            customStyle={styles.cancelBtn}
          />
          <OfoqThemeBtn name={'Confirm'} onClick={() => {
            setConfirmation1ModalState(false)
            setConfirmation2ModalState(true)
          }}
            customStyle={styles.saveBtn}

          />
        </Box>

      </FormModalContainer>

      <ConfirmationModalContainer
        modalState={confirmation2ModalState}
        setModalState={setConfirmation2ModalState}
        setFinishModalState={setFinishModalState}
        confirmationData={confirmation2ModalData}
        confirmHandlerQueries={{}}
        functionToDispatch={confirmHandler}
        customStyles={styles.confirm2}
      />

      <FinishModal
        modalState={finishModalState}
        modalChangeState={setFinishModalState}
        finishHandler={FinishHandler}
        modalTitle={modalTitle}
        modalMessage={modalMessage}
      />
    </>
  )
}

const styles = {
  formModalBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: { xs: '10px -10px 0 -10px', sm: '20px -15px 0 -15px' },
    padding: { xs: '10px 10px 0', md: '20px 15px 0' },
    borderTop: '1px solid #cbcbcb',
  },
  companyInputContainer: {
    marginTop: { xs: '10px', sm: '20px' },
  },
  modalBtn: {
    textTransform: 'capitalize',
    fontSize: { xs: '10px', md: '14px' },
    color: 'white',
    backgroundColor: '#29CC8B',
    width: { xs: '25vw', md: '100%' },
    minWidth: { xs: '100px', md: '130px' },
    minHeight: { xs: '30px', md: '40px' },
    borderRadius: '10px',
    '&:hover': {
      color: 'white',
      backgroundColor: '#29CC8B',
    },
  },
  companyInput: {
    '@media (max-width: 480px)': {
      '& .MuiOutlinedInput-root': {
        fontSize: '12px',
      },
      '& input::placeholder': {
        fontSize: '12px',
      },
      '& .MuiInputLabel-root': {
        fontSize: '12px',
      },
      '& .MuiOutlinedInput-input': {
        height: '1em',
      },
    },
  },
  DropdownInput: {
    mt: '10px',
    '@media (max-width: 480px)': {
      '& .MuiInputLabel-root': {
        fontSize: '12px',
      },
      '& .MuiOutlinedInput-root': {
        fontSize: '12px',
      },
      '& .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
        minHeight: 'auto',
      },
      '& .MuiOutlinedInput-input.MuiSelect-select': {
        height: '1em',
      },
    },
  },
  autoCompleteInput: {
    '@media (max-width: 480px)': {
      '& .MuiInputLabel-root': {
        fontSize: '12px',
      },
      '& .MuiOutlinedInput-root': {
        fontSize: '12px',
      },
      '& .MuiOutlinedInput-input': {
        height: '1em',
      },
      '& .MuiAutocomplete-root .MuiChip-label': {
        fontSize: '12px',
        height: '16px',
      },
      '& .MuiChip-deleteIcon': {
        width: '14px',
      },
      '& .MuiPaper-root-MuiAutocomplete-paper': {
        fontSize: '12px',
        minHeight: 'auto',
      },
    },
  },
  actionBtn: {
    '@media (max-width: 480px)': {
      width: '25vw',
      fontSize: '12px',
      height: '40px',
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: 'solid 1px #e3e4ed',
    marginTop: { xs: '10px', sm: '40px' },
    padding: '20px 10px 10px 10px',
  },
  cancelBtn: { display: { xs: 'none', sm: 'initial' } },
  saveBtn: {
    minWidth: { xs: '100%', sm: 'initial' },
    minHeight: '40px',
    fontSize: '14px',
  },
  span: {
    pt: '10px',
    lineHeight: '40px',
    '& span': {
      fontWeight: 'bold',
    },
  },
  span2: {
    color: '#98a9bc',
  },

  confirm2: {
    '& .main-text': {
      fontWeight: 'bold',
    },
    '& .finishModalBody': {
      lineHeight: '40px',
    },
  },
}

export default CompanyModal
